import { BaseRequestPolicy, HttpOperationResponse, RequestPolicy, RequestPolicyOptionsLike, WebResourceLike } from '@azure/core-http';
import { getCookie } from 'common/utilities/Cookie';

export interface IAntiforgeryTokenPolicyOptions {
  // Name of the cookie that was returned from the service from which we
  // should grab the value and send it back as a requeset header.
  responseCookieName: string;

  // Name of the request header for the antiforgery token (CSRF / XSRF token).
  requestHeaderName: string;
}

export class AntiforgeryTokenPolicy extends BaseRequestPolicy {
  private antiforgeryOptions: IAntiforgeryTokenPolicyOptions;

  constructor(nextPolicy: RequestPolicy, options: RequestPolicyOptionsLike, antiforgeryOptions: IAntiforgeryTokenPolicyOptions) {
    super(nextPolicy, options);
    this.antiforgeryOptions = antiforgeryOptions;
  }

  sendRequest(webResource: WebResourceLike): Promise<HttpOperationResponse> {
    const antiforgeryHeaderToken = getCookie(this.antiforgeryOptions.responseCookieName);

    if (antiforgeryHeaderToken) {
      webResource.headers.set(this.antiforgeryOptions.requestHeaderName, antiforgeryHeaderToken);
    }

    return this._nextPolicy.sendRequest(webResource);
  }
}
